<template>

  <div>
            <br>
            <br>
			<el-form :model="Form" :label-position="labelPosition"  :rules="FormRules" ref="Form">
				<el-form-item label="队伍中文全称" prop="Name" >
					<el-input v-model="Form.Name" auto-complete="off"></el-input>
				</el-form-item>			
            <el-form-item label="队伍中文简称" prop="ShortName" >
					<el-input  v-model="Form.ShortName" auto-complete="off"></el-input>
				</el-form-item>
            <el-form-item label="首字母简称" prop="PhoneticName" >
					<el-input  :disabled="true" v-model="Form.PhoneticName" auto-complete="off"></el-input>
				</el-form-item>                
        	<el-form-item label="国籍" prop="Citizenship">
					<el-input   v-model="Form.Citizenship" auto-complete="off"></el-input>
				</el-form-item>
				<el-form-item label="区号" prop="AreaCode">
					<el-input   v-model="Form.AreaCode" auto-complete="off"></el-input>
				</el-form-item>
 				<el-form-item label="队伍类型" prop="TeamType">
                  <el-select v-model="Form.TeamType"  clearable placeholder="请选择队伍类型" style="width:100%">
                <el-option 
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
               </el-option>
   
                                                                           
                 </el-select>
                </el-form-item>
                <el-form-item label="开票单位名称">
					<el-input  v-model="Form.Unit" auto-complete="off"></el-input>
				</el-form-item> 
				<el-form-item label="税号" >
					<el-input  v-model="Form.TaxNumber" auto-complete="off"></el-input>
				</el-form-item>                              
				<el-form-item label="备注">
					<el-input type="textarea" v-model="Form.Remark"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
			</div>
</div>
</template>

<script>
	import {mapGetters} from 'vuex';
   import {GetInfo,EditInfo} from  '../../api/api';
  export default {
    data(){
      return{
				value: [],

      				
        // addFormVisible: true,//新增界面是否显示
				addLoading: false,
			
				FormRules: {
		  Name: [
						{ required: true, message: '请输入队伍中文全称', trigger: 'blur' }
          ],
          ShortName: [
						{ required: true, message: '请输入队伍中文简称', trigger: 'blur' }
          ],
          TeamType:[
            
          {required:true,message:'请选择队伍类型',trigger: 'blur'}
            
          ],
          Citizenship:[
            
          {required:true,message:'请输入国籍',trigger: 'blur'}
            
          ],
          AreaCode:[
            
          {required:true,message:'请输入行政区代码',trigger: 'blur'}
            
          ],
          // Unit:[
            
          // {required:true,message:'请输入开票单位名称',trigger: 'blur'}
            
          // ],
          //           TaxNumber:[
            
          // {required:true,message:'请输入税号',trigger: 'blur'}
            
          // ]

          
				},
        //新增界面数据
				labelPosition: 'top',
				shopinfo:[],
				Form: {					
                },
                 options: [{
                     value: '0',
                    label: '国家队'
                    }, {
                      value: '1',
                     label: '省市队伍'
                    },
                     {
                     value: '2',
                     label: '院校队伍'
                    }, 
                      {
                     value: '3',
                     label: '俱乐部队伍'
                    }, 
                      {
                     value: '4',
                     label: '企业队伍'
                    }, 
                     {
                     value: '5',
                     label: '部队队伍'
                    }, 
                      {
                     value: '6',
                     label: '协会队伍'
                    }, 
                      {
                     value: '7',
                     label: '单位临时队伍'
                    },
                      {
                     value: '8',
                     label: '其他'
                    },                    
                   
                    ],                
                
      }
    },
 
beforeRouteLeave: function(to, from , next){
        
        this.$confirm('您确定要离开当前页面么？', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async()=>{ 
          next();
        }
        ).catch(() => {
                  next(false)
        });
     },

   
   methods: {
      handleChange(value) {
        console.log(value);
      },
    	 
		 ...mapGetters(['getuserstate']),
        //显示新增界面
	   getInfo:function(){
					let TenancyId=JSON.parse(this.getuserstate()).TenancyId;
					// console.log(localhoststoryid.storyid);
					let para ={
						TenancyId:TenancyId
					}
           GetInfo(para).then((res)=>{
                       
						 let { Success,Msg } = res.data;
						 if(Success){
                         this.Form=res.data.Data;
                         this.Form.TeamType=res.data.ExtendData;
						 }


						//  let list=res.data;
					 })
		 },
     editSubmit: function () {
				this.$refs.Form.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.addLoading = true;
							//NProgress.start();
                            let para = Object.assign({}, this.Form);
                            console.log(this.Form);
							EditInfo(para).then((res) => {
								this.addLoading = false;
                                //NProgress.done();
 								let { Success,Msg } = res.data;
								if(Success)
								{
                                    this.$message({
									message: Msg,
									type: 'success'
									});
                                      this.getInfo();

								}else
								{
                                   this.$message({
									message: Msg,
									type: 'error'
                                    });
                                    this.getInfo();
								}
								this.$refs['Form'].resetFields();
								
							}) .catch(error=>{
             alert('系统错误');
            });
						});
					}
				});
			}
			 },
			 mounted() {
			this.getInfo();
		}


	}

</script>


// WEBPACK FOOTER //
// Team.vue?b80d143a